import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface TrendingHomePostVM {
    userID: number;
    userName: string;
    profileName: string;
    userImg: string;
    postContent: string;
    likes: number;
    reposts: number;
    comments: number;
    categoryTag?: string;
    animationDelayMs?: number;
}

@Component({
    selector: 'app-trending-post-card',
    templateUrl: './trending-post-card.component.html',
    styleUrls: ['./trending-post-card.component.scss']
})
export class TrendingPostCardComponent implements OnChanges {
    @Input() post: TrendingHomePostVM;

    /** Set when api/content/logo fails (e.g. SQL offline); show letter fallback. */
    avatarLoadFailed = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['post']) {
            this.avatarLoadFailed = false;
        }
    }

    avatarLetter(): string {
        const n = this.post?.profileName || this.post?.userName || '?';
        return n.trim().charAt(0).toUpperCase();
    }

    /** Same source as dashboard: API streams file from legacy ~/img_profile via DB. */
    profileImgUrl(): string | null {
        if (!this.post?.userID || this.avatarLoadFailed) {
            return null;
        }
        return `api/content/logo?userID=${this.post.userID}`;
    }

    onAvatarError(): void {
        this.avatarLoadFailed = true;
    }
}
